export default __webpack_public_path__ + "static/media/ipc-no01.b7dda713.svg";